import { CategoryType, CompaniesMapType, RelationsType, TableModelType } from './types';

export function getTableModel(categoriesRelations: RelationsType): TableModelType {
    const tableModel = categoriesRelations
        .filter((category) => category.categoryName !== 'Headline')
        .map((categoryRelation) => {
            const category: CategoryType = {
                categoryId: categoryRelation.categoryId,
                categoryName: categoryRelation.categoryName.trim(),
                companiesMap: {},
                descriptorsCount: 0,
            };

            category.companiesMap = categoryRelation.schemaRelations.reduce((acc, schemaRelation) => {
                const companyId = schemaRelation.companyId;
                /**
                 * check if company exists in company relations
                 * if company does not yet exist add it to the relations
                 */
                if (!acc[companyId]) {
                    acc[companyId] = {
                        companyId: companyId,
                        companyName: schemaRelation.companyName,
                        schemasMap: {},
                        descriptorsCount: 0,
                    };
                }
                const company = acc[companyId];
                const schemaId = schemaRelation.schemaId;
                /**
                 * Check if schema exists for the company
                 * if schema does not yet exist add it to the schemas
                 */
                if (!company.schemasMap[schemaId]) {
                    company.schemasMap[schemaId] = {
                        schemaId: schemaId,
                        schemaName: schemaRelation.schemaName,
                        descriptors: [],
                    };
                }

                company.schemasMap[schemaId].descriptors.push(...schemaRelation.descriptors);
                company.descriptorsCount += schemaRelation.descriptors.length;
                category.descriptorsCount += schemaRelation.descriptors.length;

                return acc;
            }, {} as CompaniesMapType);

            return category;
        });

    tableModel.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
    return tableModel;
}
